var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgModalDocumentIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7932 2.41455H17.5859V6.03628H20.0004V3.62179C20.0004 2.95499 19.46 2.41455 18.7932 2.41455Z",
    fill: "#FFA436"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7928 3.62173L15.171 8.4507H0V1.20724C0 0.540443 0.540443 0 1.20724 0H7.08531C7.40563 0 7.71268 0.127163 7.93923 0.353722L10 2.41449H17.5855C18.2523 2.41449 18.7928 2.95493 18.7928 3.62173Z",
    fill: "#FFBC2B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5854 3.62183L15.1709 6.63993H18.7926V3.62183H17.5854Z",
    fill: "#8AE7FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5853 3.62183V9.65804L1.20703 4.82907V3.62183H17.5853Z",
    fill: "#BDF2FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.20703 4.82886H12.9145V8.45059H1.20703V4.82886Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7932 4.82886L17.5859 6.0361V18.189H18.7932C19.46 18.189 20.0004 17.6486 20.0004 16.9818V6.0361C20.0004 5.3693 19.46 4.82886 18.7932 4.82886Z",
    fill: "#FFBC2B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7928 4.82886V16.9818C18.7928 17.6486 18.2523 18.189 17.5855 18.189H1.20724C0.540443 18.189 0 17.6486 0 16.9818V8.45059C0 7.78379 0.540443 7.24334 1.20724 7.24334H10L12.0608 5.18258C12.2873 4.95602 12.5944 4.82886 12.9147 4.82886H18.7928Z",
    fill: "#FFCF66"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalDocumentIcon);
export default __webpack_public_path__ + "static/media/modal-document-icon.ea4fc6ccc54f41895e3c35098fb6e7d7.svg";
export { ForwardRef as ReactComponent };